import { service } from '@ember/service';
import Modifier from 'ember-modifier';
import { registerDestructor } from '@ember/destroyable';
import type ModalService from 'walden-trace-app/services/modal';

interface ModalSignature {
  Element: HTMLDialogElement;
  Args: {
    Positional: [string];
  };
}

export default class ModalModifier extends Modifier<ModalSignature> {
  @service('modal') declare modalService: ModalService;

  modify(element: HTMLDialogElement, [id]: [string]): void {
    this.modalService.register(id, element);
    registerDestructor(this, () => {
      this.modalService.unregister(id);
    });
  }
}
